var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"error_404"},[_vm._m(0),_c('p',{staticClass:"error-text"},[_vm._v("哎呀，出错了！您访问的页面不存在......")]),_c('p',{staticClass:"error-btn",on:{"click":_vm.handleLogin}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回登录")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{attrs:{"src":require("../assets/images/error-404.png")}})])
}]

export { render, staticRenderFns }